export default __webpack_public_path__ + "static/media/darkCollisionWarning.9476a946.png";